export enum StaffTypeRequiresEnrollmentSlugs {
  IOP_COUNSELOR = 'iop-counselor',
  PRIMARY_COUNSELOR = 'primary-counselor',
  PEER_SUPPORTER = 'peer-supporter'
}
